// Grievances Keyword Search — case-insensitive match across narrative +
// investigationNotes + outcome; returns matching rows with the hit highlighted.
import React, { useState } from "react";
import { ReportShell, Card, Pill, highlight, val, fmtDate } from "./_shared";
import { CATEGORIES, STATUSES, categoryLabel, statusLabel } from "../grievanceModel";

const FIELDS = [
  { key: "narrative", label: "Narrative" },
  { key: "investigationNotes", label: "Investigation Notes" },
  { key: "outcome", label: "Outcome" },
];

export default function GrievanceKeywordSearch({ records = [] }) {
  const [query, setQuery] = useState("");
  const q = query.trim().toLowerCase();

  const matches = !q
    ? []
    : records
        .map((r) => {
          const hits = FIELDS.filter((f) => (r[f.key] || "").toLowerCase().includes(q));
          return hits.length ? { record: r, hits } : null;
        })
        .filter(Boolean);

  return (
    <ReportShell title="Grievances Keyword Search" subtitle="Search across narrative, investigation notes, and outcome.">
      <Card style={{ marginBottom: 16 }}>
        <input
          autoFocus
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search grievance text — e.g. medication, laundry, call light…"
          style={{ width: "100%", border: "1px solid var(--ed-line-hover)", borderRadius: 8, padding: "11px 14px", fontSize: 15, color: "#1e293b", background: "#fafbfc", outline: "none" }}
        />
        {q && <div style={{ marginTop: 10, fontSize: 13, color: "var(--ed-muted)" }}>{matches.length} match{matches.length === 1 ? "" : "es"} for “{query.trim()}”</div>}
      </Card>

      {!q ? (
        <div style={{ color: "var(--ed-muted-2)", fontSize: 14, textAlign: "center", padding: "30px 0" }}>Type a keyword above to search the grievance log.</div>
      ) : matches.length === 0 ? (
        <div style={{ color: "var(--ed-muted-2)", fontSize: 14, textAlign: "center", padding: "30px 0" }}>No grievances mention “{query.trim()}”.</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {matches.map(({ record: r, hits }) => {
            const st = STATUSES[r.status] || {};
            return (
              <Card key={r.id}>
                <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 8 }}>
                  <span style={{ fontWeight: 800, color: "var(--ed-ink)" }}>{val(r.residentName, { missing: r.complainantType !== "anonymous" })}</span>
                  <Pill label={categoryLabel(r.category)} color={CATEGORIES[r.category]?.color} bg={CATEGORIES[r.category]?.bg} />
                  <Pill label={statusLabel(r.status)} color={st.color} bg={st.bg} border={st.border} />
                  <span style={{ fontSize: 12, color: "var(--ed-muted-2)", marginLeft: "auto" }}>{r.facilityName} · {val(fmtDate(r.dateReceived))}</span>
                </div>
                {hits.map((f) => (
                  <div key={f.key} style={{ marginTop: 8 }}>
                    <div style={{ fontSize: 10.5, fontWeight: 700, color: "var(--ed-muted-2)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 3 }}>{f.label}</div>
                    <div style={{ fontSize: 13, color: "var(--ed-ink-2)", lineHeight: 1.55 }}>{highlight(r[f.key], query)}</div>
                  </div>
                ))}
              </Card>
            );
          })}
        </div>
      )}
    </ReportShell>
  );
}
